import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

export type ClientResponseOptsProps = {
  handleClosingModal: () => void;
  loadMessages: () => Promise<{
    messages: {
      title: string;
      message: string;
      requires_id?: boolean;
    }[];
    params: any;
  }>;
};

const fillTemplate = function (templateString: string, templateVars: any) {
  return new Function("return `" + templateString + "`;").call(templateVars);
};

const formatMessage = (message: string, params: any[]) => {
  const newMessage = message.replaceAll("${", "${this.");
  return fillTemplate(newMessage, params);
};

export const ClientResponseOpts = ({
  handleClosingModal,
  loadMessages,
}: ClientResponseOptsProps) => {
  const [params, setParams] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState<
    {
      title: string;
      message: string;
    }[]
  >([]);
  const [selectedMessageIndex, setSelectedMessageIndex] = useState(-1);
  const [currentMessage, setCurrentMessage] = useState("");

  useEffect(() => {
    loadMessages().then((r) => {
      setMessages(r.messages);
      setParams(r.params);
      setLoading(false);
    });
  }, []);


  useEffect(() => {
    if (selectedMessageIndex >= 0) {
      const message = messages[selectedMessageIndex];
      setCurrentMessage(() => formatMessage(message.message, params));
    }
  }, [selectedMessageIndex]);

  const encodeURIWithRegex = (msg:string) => {
    let encodedURI = encodeURI(msg);
    
    encodedURI = encodedURI.replace(/[&=+#?]/g, function (match) {
      return "%" + match.charCodeAt(0).toString(16).toUpperCase();
    });

    return encodedURI;
  }

  return (
    <Modal isOpen={true} onClose={handleClosingModal} trapFocus={true}>
      <ModalOverlay />
      <ModalContent minW={"500px"} py="1rem">
        <ModalCloseButton mt="1rem" />
        <ModalHeader>
          <Heading size="lg" mb="1rem">
            Send message to client
          </Heading>
        </ModalHeader>
        <ModalBody>
          {loading ? (
            <Box display="flex" justifyContent={"center"} alignItems={"center"}>
              <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
                size="xl"
              />
            </Box>
          ) : (
            <>
              <Stack spacing={[3, 4]} fontSize="sm" isInline mb="1.5rem">
                <FormControl mb="1rem">
                  <FormLabel htmlFor="requests">
                    Select message to send
                  </FormLabel>
                  <Select
                    placeholder="Select message to send"
                    onChange={(e) => setSelectedMessageIndex(+e.target.value)}
                    value={selectedMessageIndex}
                  >
                    {messages.map((message, index) => (
                      <option key={index} value={index}>
                        {message.title}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
                <Box mb="1rem">
                  <Text mb="0.3rem" fontWeight={"medium"}>
                    Message Preview:
                  </Text>
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      fontSize: "14px",
                      fontFamily: "Inter",
                    }}
                  >
                    {currentMessage}
                  </pre>
                </Box>
                </>
          )}
        </ModalBody>

        <ModalFooter display={"block"}>
          <Box w={"full"}>
            <Button
              colorScheme={"green"}
              float="right"
              type="submit"
              as="a"
              href={`https://wa.me/${params.phone}?text=${encodeURIWithRegex(
                currentMessage
              )}`}
              target={"_blank"}
              rel="noopener noreferrer"
            >
              Send message
            </Button>
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
